import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { ThemeOption } from '@/app/ThemeContext';
import { Link } from '@/components/Link';
import type { Repo } from '@/sections/poe/types/poe.types';
import { isValidExternalURL } from '@/utils/url.util';

// eslint-disable-next-line react-refresh/only-export-components
export const getRepoInfo = (
  url: string,
  theme: ThemeOption
): { tab: string; content: React.ReactNode } | null => {
  if (!isValidExternalURL(url)) return null; // URL hardening — added in Phase 1

  const repoTypes: Record<string, Repo> = {
    'github.com': 'Github',
    'gitlab.com': 'GitLab',
    'bitbucket.org': 'Bitbucket',
  };

  const hostname = new URL(url).hostname.toLowerCase().replace(/^www\./, '');
  const type = repoTypes[hostname];
  if (!type) return null;

  const repoIcons: Record<Repo, string> = {
    Github: `/icons/${theme}/github.svg`,
    GitLab: `/icons/${theme}/gitlab.svg`,
    Bitbucket: `/icons/${theme}/bitbucket.svg`,
  };

  return {
    tab: `${type} Link`,
    content: (
      <RepoLink
        icon={repoIcons[type]}
        tab={`${type} Link`}
        type={type}
        url={url}
      />
    ),
  };
};

export const RepoLink = ({
  icon,
  tab,
  type,
  url,
}: {
  icon: string;
  tab: string;
  type: string;
  url: string;
}) => {
  return (
    <Link
      to={url}
      target="_blank"
      rel="noopener noreferrer"
      className="p-0"
      buttonClass="flex items-center gap-2 text-chariot-brand-primary hover:text-chariot-brand-secondary m-0 p-0"
    >
      <img src={icon} alt={tab} className="m-0 size-4" />
      <span>{`View on ${type}`}</span>
      <ArrowTopRightOnSquareIcon className="size-4" />
    </Link>
  );
};
